import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";


export const PolicyCreate_UpdateSlice = createSlice({
  name: "PolicyCreate_UpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PolicyCreate_Update: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successPolicyCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePolicyCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPolicyCreate_Update: (state) => {
      state.data = {};
    },
  },
});

export const {
  PolicyCreate_Update,
  failurePolicyCreate_Update,
  successPolicyCreate_Update,
  clearPolicyCreate_Update,
} = PolicyCreate_UpdateSlice.actions;

export default PolicyCreate_UpdateSlice.reducer;
